<template>
    <a :href="link" class="video_link" data-fancybox>
        <picture v-full-image-path="value.image" />
    </a>
</template>

<script>
import { mapActions } from 'vuex';
import getMediaUrl from '@/helpers/getMediaUrl';

export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    },

    computed: {
        link() {
            return this.value.linkOnly
                ? this.value.link
                : getMediaUrl(this.value.videoData);
        }
    },

    mounted() {
        this.initFancybox();
    },

    methods: {
        ...mapActions({
            initFancybox: 'scripts/initFancybox'
        })
    }
};
</script>
